export default defineNuxtRouteMiddleware(() => {
  if (useMainStore().isAppview) {
    return;
  }

  const userStore = useUserStore();

  // Load tealium audiences and A/B tests, but skip awaiting Promises to not block the page
  void userStore.loadTealiumAudiences();
  void userStore.loadAbTests();
});
